import ls from 'local-storage'

ls.backend(window.sessionStorage)

export default ls
